import React, { useState, useEffect } from "react"
import ApplicationService from "../../services/applications/Application.service"

let appService = null

function ParticipantManagement(props) {
  const [searchQuery, setSearchQuery] = useState("")
  const [participants, setParticipants] = useState([])
  const [selectedParticipants, setSelectedParticipants] = useState([])

  useEffect(() => {
    const userObj = JSON.parse(localStorage.getItem("authUser"))
    appService = new ApplicationService(userObj)
  }, [props.targetGroup])

  const handleAddParticipant = participant => {
    let updatedList = [...selectedParticipants, participant]
    setSelectedParticipants(updatedList)
    let idsList = updatedList.map(item => item.id)
    props.handleParticipants(idsList)
  }

  const handleRemoveParticipant = participant => {
    let updatedList = selectedParticipants.filter(p => p.id !== participant.id)
    setSelectedParticipants(updatedList)
    let idsList = updatedList.map(item => item.id)
    props.handleParticipants(idsList)
  }

  const searchParticipants = async search => {
    setSearchQuery(search)
    search = search.trim()
    if (search == "") {
      setParticipants([])
      return
    }
    let group = ""
    if (props.targetGroup == "SELECTED CLIENTS") {
      group = "clients"
    } else if (props.targetGroup == "SELECTED COMPANIES") {
      group = "campanies"
    } else {
      // We don't know the target group. Quit search!
      return
    }

    appService.searchMessagingParticipants(search, group).then(response => {
      if (response.data?.length > 0) {
        setParticipants(response.data)
      } else {
        setParticipants([])
      }
    })
  }

  return (
    <div>
      <input
        type="text"
        placeholder="Search Participants"
        className="form-control"
        value={searchQuery}
        onChange={e => searchParticipants(e.target.value)}
      />
      <ul>
        {participants.map(participant => (
          <li key={participant.id}>
            {props.targetGroup == "SELECTED CLIENTS"
              ? participant.first_name +
                " " +
                participant.last_name +
                " ---> " +
                participant.email +
                " "
              : participant.name}

            <button
              className="btn btn-primary"
              onClick={() => handleAddParticipant(participant)}
            >
              Add
            </button>
          </li>
        ))}
      </ul>
      <div>
        <p>Selected Participants:</p>
        <ul>
          {selectedParticipants.map(participant => (
            <li key={participant.id}>
              {props.targetGroup == "SELECTED CLIENTS"
                ? participant.first_name +
                  " " +
                  participant.last_name +
                  " ---> " +
                  participant.email +
                  " "
                : participant.name}{" "}
              <button
                className="btn btn-danger"
                onClick={() => handleRemoveParticipant(participant)}
              >
                Remove
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default ParticipantManagement
